export const isPortrait = () => {
    if (window.matchMedia) {
        return window.matchMedia('(orientation: portrait)').matches
    }

    const screen = 'screen' in window && window.screen ? <any> window.screen : null;
    const orientation = screen && screen.orientation;

    const type = orientation && orientation.type;

    if (type) {
        return ['portrait-primary', 'portrait-secondary'].includes(type);
    }

    // gross hack
    if (window.navigator.platform === 'iPhone') {
        return window.orientation != 90 && window.orientation != -90;
    }

    // if (screen && screen.orientation) {
        /*const angle = screen.orientation.angle;

        if (angle === 90 || angle === -90) {
            return window.innerHeight < window.innerWidth;
        }
        // return ['portrait-primary', 'portrait-secondary'].indexOf(screen.orientation.type) !== -1;*/
        // return screen.width <= screen.height;
    // }

    return window.innerWidth <= window.innerHeight;
};